import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Item } from '@generic-ui/ngx-grid/core/structure/source/src/api/item/item';
import { catchError, map, Observable, throwError } from 'rxjs';
import { Category, CategoryAdapter } from '../Models/category';
import { Policy, PolicyAdapter } from '../Models/policy';
import { ApiRestService } from './api-rest.service';

@Injectable({
  providedIn: 'root'
})
export class CategoryService {
  //private apiCall = 'getcategorypolicylist/';
  categoryList : Category[];
  policyList : Policy[];

  constructor(private apiRestService: ApiRestService
            , private categoryAdapter: CategoryAdapter
            , private policyAdapter: PolicyAdapter) { }

  getCategoriesPolicies(apiCall) {
    return this.apiRestService.getJasonRestApi(apiCall, 'Schoolboard Policy').pipe(
      catchError(error => {
        return throwError(error || 'something went wrong for category mapping');
      })
    );
  }

  addCategory(apiCall, content) {
    return this.apiRestService.postJasonRestApi(apiCall, 'Schoolboard Policy', content).pipe(
      catchError(error => {
        return throwError(error || 'something went wrong for category post mapping')
      })
    );

  }
}
